import { render, staticRenderFns } from "./SwabList.vue?vue&type=template&id=49217896"
import script from "./SwabList.vue?vue&type=script&lang=js"
export * from "./SwabList.vue?vue&type=script&lang=js"
import style0 from "./SwabList.vue?vue&type=style&index=0&id=49217896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports